import PlaceTable from './place-table';

export default PlaceTable;